<template>
  <div>
    <div id="floating-background"></div>
    <div id="nav">
      <div class="container">
        <div class="row">
          <div class="col mx-0 px-0">
            <router-link
              to="/"
              class="toolbar-button"
              b-tooltip.hover
              title="Home"
            >
              <i class="far fa-home  fa-2x"></i>
            </router-link>

            <slot name="toolbar"></slot>
            <div class="freesplit-app d-none d-sm-block">
              freesplit.app
            </div>
          </div>
        </div>
      </div>
    </div>
    <div id="content">
      <slot name="content"></slot>
    </div>
    <footer>
      <div class="container">
        <div class="row">
          <div class="col text-center">
            Copyright 2020 Rennie Glen Software LLC
          </div>
        </div>
        <div class="row">
          <div class="col text-right px-0">
            <small>
              <router-link class="bottom-link" to="about">About Us</router-link>
            </small>
          </div>
          <div class="col col-5 col-md-3 text-center px-0">
            <small>
              <router-link class="bottom-link" to="terms"
                >Terms and Conditions</router-link
              >
            </small>
          </div>
          <div class="col px-0">
            <small>
              <router-link class="bottom-link" to="privacy"
                >Privacy Policy</router-link
              >
            </small>
          </div>
        </div>
      </div>
    </footer>
  </div>
</template>

<style>
.d-none {
  display: none !important;
}

.d-sm-block {
  display: block !important;
}

.mx-0 {
  margin-left: 0 !important;
  margin-right: 0 !important;
}

.px-0 {
  padding-left: 0 !important;
  padding-right: 0 !important;
}

.text-center {
  text-align: center !important;
}

.text-right {
  text-align: right !important;
}

.container {
  width: 100%;
  padding-right: 15px;
  padding-left: 15px;
  margin-right: auto;
  margin-left: auto;
}

@media (min-width: 576px) {
  .container {
    max-width: 540px;
  }
}

@media (min-width: 768px) {
  .container {
    max-width: 720px;
  }
}

@media (min-width: 992px) {
  .container {
    max-width: 960px;
  }
}

@media (min-width: 1200px) {
  .container {
    max-width: 1140px;
  }
}

.row {
  display: flex;
  flex-wrap: wrap;
  margin-right: -15px;
  margin-left: -15px;
}

.col {
  position: relative;
  width: 100%;
  padding-right: 15px;
  padding-left: 15px;
}

.col-5 {
  flex: 0 0 41.666667%;
  max-width: 41.666667%;
}

.col-md-3 {
  flex: 0 0 25%;
  max-width: 25%;
}

#nav {
  background: darkblue;
  color: rgb(205, 243, 255);
  width: 100%;
  position: fixed;
  top: 0;
  z-index: 10;
}

.toolbar-button {
  padding-top: 3px;
  padding-left: 3px;
  margin-top: 3px;
  display: inline-block;
  color: rgb(205, 243, 255);
}

.toolbar-button:hover {
  background: mediumblue;
  color: white;
}

#top-menu-item {
  /* Allow a little space for the tooltip */
  margin-top: 1em;
}

#nav button {
  margin-left: 2px;
}

#content {
  padding-top: 55px;
}

footer {
  margin-top: 2em;
}

.freesplit-app {
  position: absolute;
  top: 3px;
  right: 3px;
}

.bottom-link {
  margin-left: 1em;
  margin-right: 1em;
  text-decoration: none;
}

.bottom-link:hover {
  text-decoration: underline;
}

#floating-background {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: -1;
  background-color: white;
}

</style>